import React from 'react'
import { Bar } from 'react-chartjs-2'
import 'chartjs-plugin-annotation'
import './BarChart.scss'
import PropTypes from 'prop-types'
import { customizeChartOptions } from '@engine/utils/barChartHelper'
import { EditYAxisBarCharts } from '@components/custom'
import { EditButtonWrapper } from '@components/common'

class BarChart extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      form: false
    }
    this.chartReference = React.createRef()
  }

  handleEditDialog = () => {
    const form = !this.state.form
    this.setState({ form })
  }

  handleSubmit = data => {
    this.props.editBarChartSettings(data)
    this.setState({
      form: false
    })
  }

  render() {
    const { chartData, defaultChartOptions, pageTitle, isGrid, propertyNameOrientation, isValueOrientation, barWidth } = this.props

    return (
      <React.Fragment>
        <div data-testid="bar-chart" className="chart-page">
          <div>
            <h1
              data-testid="bar-chart-title"
              className="header-text-uppercase page-title"
            >
              {pageTitle}
            </h1>
          </div>
          <EditButtonWrapper handleEditButtonClick={this.handleEditDialog} dataTestId="bar-chart-y-axis-edit">
            <div className="bar-container">
              <Bar
                ref={this.chartReference}
                width={100}
                height={626}
                data={chartData}
                options={customizeChartOptions(
                  defaultChartOptions,
                  this.chartReference,
                  { isGrid, yaxisConfig: chartData.yaxisConfig, propertyNameOrientation, isValueOrientation, pageTitle, barWidth }
                )}
                redraw
              />
            </div>
          </EditButtonWrapper>
        </div>
        <EditYAxisBarCharts
          form={this.state.form}
          yaxisConfig={chartData.yaxisConfig}
          pageTitle={pageTitle}
          handleYAxisSubmit={this.handleSubmit}
          handleEditDialog={this.handleEditDialog}
        />
      </React.Fragment>
    )
  }
}

BarChart.propTypes = {
  editBarChartSettings: PropTypes.func,
  chartData: PropTypes.object,
  defaultChartOptions: PropTypes.object,
  pageTitle: PropTypes.string,
  isGrid: PropTypes.string,
  propertyNameOrientation: PropTypes.string,
  isValueOrientation: PropTypes.string,
  barWidth: PropTypes.number
}

export default BarChart
